/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from 'lodash';

import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';
import SalesRepContact from 'ui/components/organizations/SalesRepContact.vue';

const basicFields = [{
    field: 'display_name',
    kind: 'display-only',
    label: 'organization.details.display_name',
    disabled: true
}, {
    field: 'name',
    kind: 'display-only',
    label: 'organization.details.name'
}, {
    label: 'organization.details.sf_account_id',
    field: 'sf_account_id',
    tooltip: 'organization.details.sf_account_id_tooltip',
    validations: {
        required: true
    }
}];
const supportFields = [{
    field: 'enable_rtmps_slides',
    kind: 'boolean',
    label: 'organization.details.enable_rtmps_slides'
}, {
    field: 'show_live_captions',
    kind: 'boolean',
    label: 'organization.details.show_live_captions'
}, {
    field: 'org_industry',
    label: 'organization.details.org_industry',
    kind: 'choice',
    default: 'other',
    kind_options: {
        values: {
            life_science: 'organization.details.life_science',
            other: 'organization.details.other'
        }
    }
}];
const accountManagerFields = [{
    field: 'paid_packages',
    label: 'organization.details.paid_packages',
    kind: 'choice-list',
    kind_options: {
        multiple: true,
        emitOptionValueOnly: true,
        values: {}
    }
}];
const superadminFields = [{
    field: 'bs_is_spotme',
    kind: 'boolean',
    label: 'organization.details.bs_is_spotme',
    tooltip: 'organization.details.bs_is_spotme_tooltip',
}, {
    field: 'bs_is_blocked',
    kind: 'boolean',
    label: 'organization.details.bs_is_blocked',
}, {
    field: 'entitlements_enabled',
    kind: 'boolean',
    label: 'organization.details.entitlements_enabled',
}, {
    field: 'entitlements_v2',
    kind: 'boolean',
    label: 'organization.details.entitlements_v2',
}, {
    field: 'password_rotation_policy',
    kind: 'nested-object',
    kind_options: {
        fields: {
            enabled: {
                kind: 'boolean',
                label: 'general.enabled',
            },
            duration: {
                kind: 'number',
                label: 'organization.details.password_rotation_policy_duration',
            }
        },
        skip_save: true
    },
    label: 'organization.details.password_rotation_policy',
}, {
    field: 'enable_anonymization',
    kind: 'boolean',
    label: 'organization.details.enable_anonymization',
}, {
    field: 'allow_non_unique_email',
    kind: 'boolean',
    label: 'organization.details.allow_non_unique_email',
    tooltip: 'organization.details.allow_non_unique_email_tooltip'
}, {
    field: 'show_studio_express',
    kind: 'boolean',
    label: 'organization.details.show_studio_express',
}, {
    field: 'content_hubs_enabled',
    kind: 'boolean',
    label: 'organization.details.content_hubs_enabled',
}, {
    field: 'studio_use_chime',
    kind: 'boolean',
    label: 'organization.details.studio_use_chime',
}, {
    field: 'hive',
    kind: 'nested-object',
    kind_options: {
        fields: {
            enabled: {
                kind: 'boolean',
                label: 'general.enabled',
            },
            partnerId: {
                kind: 'text',
                label: 'organization.details.hive_partner_id',
            },
            partnerToken: {
                kind: 'text',
                label: 'organization.details.hive_partner_token',
            },
            customerId: {
                kind: 'text',
                label: 'organization.details.hive_customer_id',
            }
        },
        skip_save: true
    },
    label: 'organization.details.hive',
}];

/**
 * This components is used to set the organisation details.
 *
 * @vue-prop {Object} organization the organization object
 *
 * @category ui.pages.organizations
 * @exports OrganisationDetails
 * @component
 */
const __vue_script__ = {
    name: 'OrganisationDetails',

    components: { BaseSelect, MetaForm, SalesRepContact },

    props: {
        organization: {
            type: Object,
            required: true
        }
    },

    data() {
        const model = cloneDeep(this.organization);
        if (!model.paid_packages) {
            model.paid_packages = [];
        }

        const isSuperAdmin = this.$services.user.isSuperAdmin();
        const isAccountManager = this.$services.user.matchesRoles({ globalRole: 'spotme_am' });
        const isSupport = this.$services.user.matchesRoles({ globalRole: 'spotme_support' });

        if (!isSuperAdmin) {
            const sfAccountIdField = basicFields.find(field => field.field === 'sf_account_id');
            sfAccountIdField.kind = 'display-only';
        }

        return {
            model,
            basicFields,
            supportFields,
            accountManagerFields,
            superadminFields,
            isSuperAdmin,
            isAccountManager,
            isSupport,
            saving: false,
            pkgsLoaded: false
        };
    },

    async created() {
        if (this.isAccountManager || this.isSuperAdmin) {
            try {
                const paidPackages = await this.$services.market.getPaidPackages(this.organization._id);
                const paidPkgsField = this.accountManagerFields.find(field => field.field === 'paid_packages');
                paidPkgsField.kind_options.values = paidPackages;

                this.pkgsLoaded = true;
            } catch (err) {
                console.error('Failed to fetch paid packages', err);
            }
        }
    },

    methods: {
        async validate() {
            this.saving = true;

            try {
                await this.$refs.supportForm?.validate();
                await this.$refs.accountManagerForm?.validate();
                await this.$refs.superadminForm?.validate();
                await this.$refs.basicForm.validate();
            } catch (err) {
                this.saving = false;
            }
        },

        updateValues(data, fields) {
            for (const field of fields) {
                this.model[field.field] = data[field.field];
            }
        },

        updateSupportValues(data) {
            this.updateValues(data, this.supportFields);
        },

        updateAccountManagerValues(data) {
            this.updateValues(data, this.accountManagerFields);
        },

        updateSuperadminValues(data) {
            this.updateValues(data, this.superadminFields);
        },

        async save(data) {
            try {
                this.updateValues(data, this.basicFields);
                await this.$services.org.updateOrg(this.organization.name, this.model);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('organization.details.update_success').toString(),
                    type: 'success',
                });

                Object.assign(this.organization, this.model);
            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('organization.details.update_error').toString(),
                    type: 'error'
                });
            } finally {
                this.saving = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"organisation-details panels panels-b"},[_c('div',{staticClass:"panel"},[_c('meta-form',{ref:"basicForm",attrs:{"value":_vm.model,"fields":_vm.basicFields,"show-toolbar":false},on:{"valid":_vm.save}}),(_vm.isSupport || _vm.isSuperAdmin)?_c('div',{staticClass:"alert alert-warning"},[_c('h4',[_vm._v(_vm._s(_vm.$i18n.t('organization.details.support_options')))]),_c('meta-form',{ref:"supportForm",attrs:{"value":_vm.model,"fields":_vm.supportFields,"showToolbar":false},on:{"valid":_vm.updateSupportValues}})],1):_vm._e(),(_vm.isAccountManager || _vm.isSuperAdmin)?_c('div',{staticClass:"alert alert-warning"},[_c('h4',[_vm._v(_vm._s(_vm.$i18n.t('organization.details.account_manager_options')))]),(!_vm.pkgsLoaded)?_c('loader',{staticClass:"in-page medium",attrs:{"status":!_vm.pkgsLoaded}}):_vm._e(),(_vm.pkgsLoaded)?_c('meta-form',{ref:"accountManagerForm",attrs:{"value":_vm.model,"fields":_vm.accountManagerFields,"showToolbar":false},on:{"valid":_vm.updateAccountManagerValues}}):_vm._e()],1):_vm._e(),(_vm.isSuperAdmin)?_c('div',{staticClass:"alert alert-danger"},[_c('h4',[_vm._v(_vm._s(_vm.$i18n.t('organization.details.superadmin_options')))]),_c('meta-form',{ref:"superadminForm",attrs:{"value":_vm.model,"fields":_vm.superadminFields,"showToolbar":false},on:{"valid":_vm.updateSuperadminValues}})],1):_vm._e(),(_vm.isSupport || _vm.isAccountManager || _vm.isSuperAdmin)?_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.saving},on:{"click":_vm.validate}},[_vm._v(_vm._s(_vm.$t('general.save')))])]):_vm._e()],1),_c('div',{staticClass:"panel"},[_c('sales-rep-contact',{attrs:{"orgName":_vm.organization.name}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "OrganisationDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__